const routes = [
    {
        name: 'manage_application.index',
        path: '/applications-list',
        component: () => {
            return import('@/views/resident_lifecycle/application_service/Index.vue');
        },
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'applications and lease',
            title: 'applications and lease',
            flowStartsWith: 'manage_application.index',
            allowedRoles: ['SUPER_ADMIN'],
            product: 'application_service',
        },
    },
    {
        name: 'manage_application.details',
        path: '/applicantion/details',
        component: () => {
            return import('@/views/resident_lifecycle/application_service/Application.vue');
        },
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'application details',
            title: 'application details',
            size: 'large',
            flowStartsWith: 'manage_application.index',
            allowedRoles: ['SUPER_ADMIN'],
            product: 'application_service',
        },
    },
    {
        name: 'id_verification.report',
        path: '/applicantion/id-verification-report',
        component: () => {
            return import('@/views/resident_lifecycle/application_service/IdVerificationReport.vue');
        },
        meta: {
            loadInModal: true,
            actions: false,
            breadcrumbName: 'id verification report',
            title: 'id verification report',
            size: 'large',
            flowStartsWith: 'manage_application.index',
            allowedRoles: ['SUPER_ADMIN'],
            product: 'application_service',
        },
    },
    {
        name: 'screening.report',
        path: '/applicantion/screening-report',
        component: () => {
            return import('@/views/resident_lifecycle/application_service/ScreeningReport.vue');
        },
        meta: {
            loadInModal: true,
            actions: false,
            breadcrumbName: 'screening report',
            title: 'screening report',
            size: 'large',
            flowStartsWith: 'manage_application.index',
            allowedRoles: ['SUPER_ADMIN'],
            product: 'application_service',
        },
    },
    {
        name: 'manage_application.add_person',
        path: '/applicantion/add-person/:role',
        component: () => {
            return import('@/views/resident_lifecycle/application_service/Guarantor/AddPerson.vue');
        },
        meta: {
            loadInModal: true,
            breadcrumbName: 'add person',
            title: 'add person',
            size: 'normal',
            flowStartsWith: 'manage_application.details',
            allowedRoles: ['SUPER_ADMIN'],
            product: 'application_service',
        },
    },
    {
        name: 'manage_application.create_profile',
        path: '/applicantion/guarantor/create-profile',
        component: () => {
            return import('@/views/resident_lifecycle/application_service/Guarantor/CreateProfile.vue');
        },
        meta: {
            loadInModal: true,
            breadcrumbName: 'create profile',
            title: 'create profile',
            size: 'normal',
            flowStartsWith: 'manage_application.details',
            allowedRoles: ['SUPER_ADMIN'],
            product: 'application_service',
        },
    },
    // Leases
    {
        name: 'lease_editor.lease',
        path: '/lease/create-lease',
        component: () => {
            return import('@/views/mvp_lease_service/CreateLease.vue');
        },
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'create lease',
            title: 'create lease',
            size: 'normal',
            flowStartsWith: 'manage_application.index',
            allowedRoles: ['SUPER_ADMIN'],
            product: 'lease-service',
        },
    },
    {
        name: 'lease_editor.default_lease',
        path: '/lease/create-default-lease',
        component: () => {
            return import('@/views/mvp_lease_service/CreateDefaultLease.vue');
        },
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'create default lease',
            title: 'create default lease',
            size: 'normal',
            flowStartsWith: 'manage_application.index',
            allowedRoles: ['SUPER_ADMIN'],
            product: 'lease-service',
        },
    },
    {
        name: 'lease_editor.manage_custom_forms',
        path: '/lease/manage-custom-forms',
        component: () => {
            return import('@/views/mvp_lease_service/ManageCustomForms.vue');
        },
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'manage custom forms',
            title: 'manage custom forms',
            size: 'normal',
            flowStartsWith: 'manage_application.index',
            allowedRoles: ['SUPER_ADMIN'],
            product: 'lease-service',
        },
    },
    {
        name: 'lease_editor.print_menu',
        path: '/lease/forms-selection',
        component: () => {
            return import('@/views/mvp_lease_service/PrintMenu.vue');
        },
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'forms selector',
            title: 'forms selector',
            size: 'normal',
            flowStartsWith: 'manage_application.index',
            allowedRoles: ['SUPER_ADMIN'],
            product: 'lease-service',
        },
    },
    {
        name: 'lease_editor.esignature_tracker',
        path: '/lease/e-signature/tracker',
        component: () => {
            return import('@/views/mvp_lease_service/ESignatureTracker.vue');
        },
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'lease e-signature tacker',
            title: 'lease e-signature tracker',
            size: 'normal',
            flowStartsWith: 'manage_application.index',
            allowedRoles: ['SUPER_ADMIN'],
            product: 'lease-service',
        },
    },
];

export default routes;
